export default __webpack_public_path__ + "static/media/eye.ee7f6a07.svg";